// extracted by mini-css-extract-plugin
export default {"checkbox":"NxCheckbox_checkbox__qVLRE","row":"NxCheckbox_row__4YV00","row_translucent":"NxCheckbox_row_translucent__InVtT"};